export const STICKER = 'STICKER';
export const VOICE_RECORDING = 'VOICE_RECORDING';